<template>
    <v-navigation-drawer
            v-if="authenticated"
            permanent
            clipped
            bottom
            disable-resize-watcher
            :expand-on-hover="mini"
            app
            mini-variant-width="54"
            class="pl-nav"
            v-model="drawerVisible"
    >
        <template v-slot:prepend>
          <global-search v-show="!mini" class="hidden-md-and-up ma-4"/>
        </template>
        <template v-for="item in items.filter((item)=>!item.availableOnlyInLang || item.availableOnlyInLang && item.availableOnlyInLang === lang)">
            <v-list-group
                    v-if="item.children && (userHasRight(item.right) || ! item.right) && item.is_hidden!==true"
                    :key="item.text"
                    v-model="openedItem[item.category_name]"
                    :prepend-icon="item.icon"

            >
                <template slot="append-icon">
                    <v-icon>{{item.model ?  'fa-chevron-down' : 'fa-chevron-up'}}</v-icon>
                </template>
                <template v-slot:activator>

                        <v-list-item-content>
                            <v-list-item-title>
                                {{ $t(item.text) }}
                            </v-list-item-title>
                        </v-list-item-content>

                </template>
                <v-list-item
                        v-for="(child, i) in item.children"
                        :key="i"
                        :class=" {'ml-5': !mini}"
                        :to="(child.route)?''+child.route:null"
                        @click="child.method?clickMethod(child.method):''"
                >
                    <v-list-item-action v-if="child.icon" min-width="30">
                        <v-icon>{{ !mini?child.icon:'mdi-checkbox-blank-circle' }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t(child.text) }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-group>
            <v-list-item
                    :to="''+item.route"
                    v-if="( ! item.children &&(userHasRight(item.right) || ! item.right)) && item.is_hidden !== true"
                    :key="item.text"
                    @click=""
            >
                <v-list-item-action>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t(item.text) }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
        <template v-slot:append>
            <template v-for="item in footerItems">
                <v-list-group
                        v-if="item.children"
                        :key="item.text"
                        v-model="item.model"
                        :prepend-icon="item.icon"
                        :append-icon="item.model ? 'fa-chevron-circle-up' : 'fa-chevron-circle-down'"
                >
                    <template v-slot:activator>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ $t(item.text) }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                    <v-list-item
                            :to="(child.route)?''+child.route:null"
                            v-for="(child, i) in item.children"
                            :key="i"
                            @click="child.method?clickMethod(child.method):''"
                    >
                        <v-list-item-action v-if="child.icon">
                            <v-icon>{{ child.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ $t(child.text) }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
                <v-list-item
                        v-else
                        :key="item.text"
                        :to="(item.route)?''+item.route:null"
                        @click="item.method?clickMethod(item.method):''"
                >
                    <v-list-item-action>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t(item.text) }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>
        </template>
    </v-navigation-drawer>
</template>

<script>
  import { mapState } from 'vuex';
  import router from "../../router";
  import RightsMixin from "@/mixins/rights";
  import {mapFields} from "vuex-map-fields";
  import GlobalSearch from "@/components/common/GlobalSearch";
  export default {
    name: "NavigationDrawerComponent",
    components: {GlobalSearch},
    mixins: [RightsMixin],
    props: {
        mini: Boolean
    },
    data: () => ({
        openedItem: {},
        drawerVisible: true
    }),
    mounted(){
      this.$store.dispatch('navigation_menu/get')
    },
    created(){
      let openedItem = [];
      for(let i in this.items){
        if(this.items[i].route === this.$route.path) openedItem[this.items[i].category_name] = true;
        if(this.items[i].children){
          for(let j in this.items[i].children){
            if(this.items[i].children[j].route === this.$route.path) {
              openedItem[this.items[i].category_name] = true;
            }
          }
        }
      }
      this.$set(this, 'openedItem', openedItem);
    },
    computed: {
      ...mapState('auth', ['authenticated']),
      ...mapState('navigation_menu', ['items', 'footerItems']),
      ...mapFields("site", ["lang"]),
    },
    methods:{
      clickMethod(method){
        this.$emit(method)
      }
    },
    watch: {
      'mini'(to, from){

      },
      '$route' (to, from) {
        let openedItem = [];
        for(let i in this.items){
          if(this.items[i].route === this.$route.path) openedItem[this.items[i].category_name] = true;
          if(this.items[i].children){
            for(let j in this.items[i].children){
              if(this.items[i].children[j].route === this.$route.path) {
                openedItem[this.items[i].category_name] = true;
              }
            }
          }
        }
        this.$set(this, 'openedItem', openedItem);
      }
    },

  }
</script>

<style scoped>
    .pl-nav .v-list-item__action{
        max-width: 25px;
    }
</style>